import { ReactElement } from 'react'
import { StyledBasisTypes } from '../basistypes'
import { CompanyTypeCards } from '../chemistry'
import { PageTemplate } from '../chemistry/skeleton'
import { Props } from './props'

const CompanyProductPickTemplate = ({
    isLoading,
    productsHandler,
}: Props): ReactElement => {

    return (
        <PageTemplate
            Top={
                <StyledBasisTypes>
                    <CompanyTypeCards
                        isLoading={isLoading}
                        productsHandler={productsHandler}
                    />
                </StyledBasisTypes>
            }
            Body={<></>}
            Modal={<></>}
        />
    )
}

export default CompanyProductPickTemplate
